var map = {
	"./calendar.svg": 80180,
	"./calendar_add_on.svg": 63131,
	"./calendar_grey.svg": 72706,
	"./call_green.svg": 35272,
	"./cancel.svg": 95940,
	"./case_add_btn.svg": 88311,
	"./check_blue.svg": 71547,
	"./check_white.svg": 60105,
	"./left_arrow.svg": 10916,
	"./next_time.svg": 27416,
	"./profile_picture.svg": 74580,
	"./profile_picture1.svg": 33288,
	"./report_add.svg": 19704,
	"./right_arrow.svg": 32155,
	"./summary_add_btn.svg": 39230,
	"./time.svg": 10012,
	"./video_camera.svg": 77333,
	"./video_green.svg": 55186
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13110;